import { CSSProperties } from 'react';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass, textEllipsis } from '../../../style';
import { PageHeaderStyles } from '../../layout/PageHeaderStyles';

const cssPrefix = 'Breadcrumbs';

export namespace BreadcrumbStyles {
  export const BreadcrumbContainerInTopBar = cssClass(cssPrefix, 'container', textEllipsis, {
    display: 'inline-block',
    flexShrink: 0,
    height: PageHeaderStyles.height,
    lineHeight: PageHeaderStyles.height,
    fontFamily: CommonStyles.Fonts.HeavyFont,
    fontSize: CommonStyles.Sizes.NormalFontSize,
  });

  export const BreadcrumbList = cssClass(cssPrefix, 'list', {
    listStyle: 'none',
    margin: '0',
    paddingLeft: '0'
  });

  const BreadcrumbStyles: CSSProperties = {
    paddingRight: CommonStyles.Sizes.DefaultSpace,
    fontSize: CommonStyles.Sizes.NormalFontSize,
    display: 'inline'
  };

  export const Breadcrumb = cssClass(cssPrefix, 'breadcrumb', BreadcrumbStyles);

  export const NonLinkBreadcrumb = cssClass(cssPrefix, 'breadcrumb-non-link', {
    ...BreadcrumbStyles,
    fontFamily: CommonStyles.Fonts.HeaderFont
  });

  export const BreadcrumbDivider = cssClass(cssPrefix, 'divider', {
    cursor: 'default',
    paddingRight: CommonStyles.Sizes.DefaultSpace,
    fontFamily: CommonStyles.Fonts.HeaderFont
  });
}
